import { t } from "@/i18n-js/instance";

export const SEND_MESSAGE_FORM_DEFAULT_VALUES = {
  text: "",
  type: "",
  area: "",
  priority: "",
} as const;

export const WIDGET_HIDDEN_ROUTES = [
  "/messages/new",
  "/messages",
  "/live",
  "/workflows/edit",
  "/workflows/new",
  "/workflows/view",
  "/discover",
  "/settings/branded_apps_builder_ui",
  "/settings/pages/edit",
] as const;

export const FIVE_MINUTES = 5 * 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

export const TICKET_TYPES = [
  { text: t("support_widget.constants.bug"), value: "bug" },
  { text: t("support_widget.constants.question"), value: "question" },
] as const;

export const PRODUCT_AREAS = [
  { text: t("support_widget.constants.admin_billing"), value: "admin_billing" },
  { text: t("support_widget.constants.apps"), value: "apps" },
  { text: t("support_widget.constants.courses"), value: "courses" },
  { text: t("support_widget.constants.events"), value: "events" },
  {
    text: t("support_widget.constants.live_streams_and_rooms"),
    value: "live_streams_and_rooms",
  },
  {
    text: t("support_widget.constants.member_access"),
    value: "member_access",
  },
  {
    text: t("support_widget.constants.paywalls"),
    value: "paywalls",
  },
  {
    text: t("support_widget.constants.posts_and_comments"),
    value: "posts_and_comments",
  },
  { text: t("support_widget.constants.settings"), value: "settings" },
  { text: t("support_widget.constants.other"), value: "other" },
] as const;

export const TICKET_PRIORITIES = [
  {
    text: t(
      "support_widget.constants.ticket_priorities.i_have_a_question_or_feedback",
    ),
    value: "low_i_have_a_question_or_feedback",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_non_critical_issue_is_slowing_me_down",
    ),
    value: "low_a_non_critical_issue_is_slowing_me_down",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_critical_issue_is_impacting_some_members_of_my_community",
    ),
    value: "high_a_critical_issue_is_impacting_some_members_of_my_community",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_member_or_admin_cannot_access_their_account",
    ),
    value: "urgent_a_member_or_admin_cannot_access_their_account",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_major_feature_does_not_work_for_my_community",
    ),
    value: "urgent_a_major_feature_does_not_work_for_my_community",
  },
];
